<template>
	<div class="row">
		<p class="col f-20 f-m-14 margin-0 align-self-center">
			<strong>{{ title }} </strong>
		</p>
		<button v-if="isModal" class="btn btn-custom float-right margin-0 pd-10" data-toggle="modal" :data-target="target">
			<span>
				<i class="fas fa-plus-circle"></i>
			</span> {{ btnText }}
		</button>
		<router-link :to="target" v-else href="javascript:;" class="btn btn-custom float-right margin-0 pd-10">
	        <span><i class="fas fa-plus-circle"></i></span>
	        {{ btnText }}
	    </router-link>
	</div>
</template>

<script>
export default {
	name: 'HeaderContent',
	props: ['title', 'btnText', 'isModal', 'target']
}
</script>